import { configureStore } from '@reduxjs/toolkit';
import contactSlice from './contact.slice';
import worksSlice from './works.slice';
import homeSlice from './home.slice';
import configSlice from './config.slice';
import cabaneSlice from './cabane.slice';
import otherProjectsSlice from './otherProjects.slice';

export default configureStore({
  reducer: {
    contact: contactSlice,
    works: worksSlice,
    home: homeSlice,
    config: configSlice,
    cabane: cabaneSlice,
    other_projects: otherProjectsSlice,
  },
});
